export enum UpgradeStateType {
    AVAILABLE = "AVAILABLE",
    FIX = "FIX",
    LOCKED = "LOCKED",
    DONE = "DONE"
}